module.exports = __webpack_public_path__ + "static/media/Apple iPad Air Gold.588f5157.png";